import { configureStore } from "@reduxjs/toolkit";
import employeeSlice from "./employee";
import giftCardSlice from "./giftCard";
import snackBarSlice from "./SnackBar";
import loggedInSlice from "./isLoggedIn";

const store = configureStore({
  reducer: {
    employees: employeeSlice.reducer,
    giftCard: giftCardSlice.reducer,
    snackBar: snackBarSlice.reducer,
    login: loggedInSlice.reducer
  },
  devTools: process.env.NODE_ENV !== "production"
});

export default store;
